import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const FinalCTA = ({ onBookDemo }) => {
  return (
    <section className="py-20 sm:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl sm:rounded-[36px] bg-slate-900 px-5 sm:px-10 lg:px-16 py-12 sm:py-16 lg:py-20 text-center">
          {/* glow */}
          <div className="absolute -top-32 -left-20 h-80 w-80 bg-emerald-500/30 blur-3xl rounded-full" />
          <div className="absolute -bottom-32 -right-20 h-80 w-80 bg-blue-500/30 blur-3xl rounded-full" />
          <div className="absolute inset-0 hero-grid opacity-[0.07]" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-emerald-300">
              <Sparkles className="h-3.5 w-3.5" /> Start in under 5 minutes
            </div>
            <h2 className="mt-6 text-3xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
              Turn WhatsApp Into Your <br className="hidden sm:block" />
              <span className="bg-gradient-to-r from-emerald-300 to-blue-300 bg-clip-text text-transparent">Highest Converting Sales Channel</span>
            </h2>
            <p className="mt-5 max-w-xl mx-auto text-base sm:text-lg text-slate-300">
              Join {BRAND.trust.clients} businesses using Wappit to automate lead generation, customer support and sales conversations on WhatsApp.
            </p>
            <p className="mt-3 max-w-xl mx-auto text-xs sm:text-sm text-emerald-300/90 font-semibold tracking-wide">
              Go Live in 24–48 Hours · Dedicated Support · No Credit Card Required
            </p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
              <Button
                onClick={onBookDemo}
                data-testid="final-cta-primary"
                className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white h-12 px-7 text-base font-semibold shadow-xl hover:-translate-y-0.5 transition-all"
              >
                Book Demo <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <a
                href={BRAND.whatsapp.waLink}
                target="_blank"
                rel="noreferrer"
                data-testid="final-cta-whatsapp"
                className="inline-flex items-center justify-center rounded-full h-12 px-7 text-base font-semibold border border-emerald-400/40 bg-emerald-400/10 text-emerald-200 hover:bg-emerald-400 hover:text-slate-900 transition-all"
              >
                <MessageCircle className="mr-2 h-4 w-4" /> WhatsApp Now
              </a>
              <Button
                variant="outline"
                onClick={onBookDemo}
                data-testid="final-cta-secondary"
                className="rounded-full h-12 px-7 text-base font-semibold border-white/20 bg-white/0 text-white hover:bg-white hover:text-slate-900"
              >
                Talk To Expert
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
